import React, { useRef, useState } from "react";
import ImgIcon from "../../Components/Common/svg/imgicon";
import FileIcon from "../../Components/Common/svg/fileicon";
import SendMsgSvg from "../../Components/Common/svg/sendmsg";
import { useMutation } from "react-query";
import { createMessages } from "../../MyApi/message";
import { Spinner } from "reactstrap";
import { toast } from "react-toastify";

const ChatActions = ({ modalId, setMessagesArr, refetch ,scrollToBottom  ,refetchChat}) => {
  const user = JSON.parse(localStorage.getItem("user"));
  const [file, setFile] = useState(null);
  //message status loading ,success ,error
  const [content, setContent] = useState("");
  const imgRef = useRef();
  const handleContentChange = (e) => {
    setFile(null)
    setContent(e.target.value);
  };
  const mutation = useMutation({
    mutationKey: ["sendmessage"],
    mutationFn: (postData) => createMessages(postData),
    onMutate: async (data) => {
      const tempMessage = {
        id: Date.now(),
        content,
        sender_id: user.id,
         sender_type:"admin",
        status: "loading",
      };
      scrollToBottom()
      setMessagesArr((prev) => [...prev, tempMessage]);
      return tempMessage;
    },
    onSuccess: (data, variables, tempMessage) => {
      setMessagesArr((prev) =>
        prev.map((msg) =>
          msg.id === tempMessage.id
            ? {
                id: msg.id,
                content: msg.content,
                sender_id: user.id,
                sender_type:"admin",
                status: "success",
              }
            : msg
        )
      );
      setContent("");
      refetch();
      refetchChat();
      scrollToBottom()
    },
    onError: (error, variables, tempMessage) => {
      toast.error(`${error.response.data.message}`);
      setMessagesArr((prev) =>
        prev.map((msg) =>
          msg.id === tempMessage.id ? { ...msg, status: "error" } : msg
        )
      );
    },
  });
  const handleUploadImg = (e) => {

   setFile(e.target.files[0]);
  };

  const handleSendMessage = () => {
       const formData = new FormData();
          formData.append("conversation_id", modalId);
   
    if (file) {
      formData.append("content", file);
   
      formData.append("type", "image");
      mutation.mutate(formData);
    }else{
          formData.append("content", content);
        formData.append("type","text")
          mutation.mutate(formData);
    }
  };
  return (
    <>
      {/* <div className="d-flex align-items-center justify-content-end mt-2 gap-2">
        <button className="msg-direct">تم حل المشكلة</button>
        <button className="msg-direct">قيد المراجعة</button>

        <button className="msg-direct">ترحيب</button>
      </div> */}

      <div className="d-flex mt-3 gap-2">
        <button
          disabled={mutation.isLoading || (!content && !file)}
          className="btn btn-primary send-btn  d-flex align-items-center justify-content-center gap-1  mb-4 "
          onClick={handleSendMessage}
        >
          <span>إرسال </span>
          {mutation.isLoading ? <Spinner size={"sm"} /> : <SendMsgSvg />}
        </button>
        <textarea
          onChange={handleContentChange}
          placeholder="اكتب رسالتك هنا..."
          className="msg-direct w-100 h-auto"
          value={content}
        ></textarea>
        {/* <button className="msg-direct" onClick={() => imgRef.current.click()}>
          <ImgIcon />
        </button>
        <input type="file" ref={imgRef} hidden onChange={handleUploadImg} />
        <button className="msg-direct">
          <FileIcon />
        </button> */}
      </div>
    </>
  );
};

export default ChatActions;
